import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useRef } from 'react';

function Card({ title, description, onClick, }) {
    return (jsx("div", Object.assign({ className: "tw:max-w-72 tw:rounded-xl tw:border tw:border-gray-200 tw:bg-white tw:shadow-sm tw:p-4 hover:tw:shadow-lg hover:tw:border-gray-300 tw:transition-all tw:duration-200 tw:cursor-pointer tw:text-left", onClick: onClick }, { children: jsxs("div", Object.assign({ className: "tw:space-y-2" }, { children: [jsx("h4", Object.assign({ className: "tw:text-sm tw:font-semibold tw:text-gray-900 tw:leading-tight" }, { children: title })), jsx("p", Object.assign({ className: "tw:text-sm tw:text-gray-600 tw:leading-relaxed" }, { children: description }))] })) })));
}
const AnimatedMasonryGrid = ({ items, onItemClick, }) => {
    const [isPaused, setIsPaused] = useState(false);
    const containerRef = useRef(null);
    // Split items into 3 rows for masonry effect
    const rows = [
        items.filter((_, i) => i % 3 === 0),
        items.filter((_, i) => i % 3 === 1),
        items.filter((_, i) => i % 3 === 2),
    ];
    // Duplicate items for seamless loop
    const duplicatedRows = rows.map((row) => [...row, ...row]);
    return (jsxs("div", Object.assign({ ref: containerRef, style: {
            width: "100%",
            overflow: "hidden",
            position: "relative",
            maskImage: "linear-gradient(to right, transparent, black 10%, black 90%, transparent)",
            WebkitMaskImage: "linear-gradient(to right, transparent, black 10%, black 90%, transparent)",
        }, onMouseEnter: () => setIsPaused(true), onMouseLeave: () => setIsPaused(false) }, { children: [jsx("style", { children: `
          @keyframes scroll-left {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-50%);
            }
          }

          @keyframes scroll-right {
            0% {
              transform: translateX(-50%);
            }
            100% {
              transform: translateX(0);
            }
          }

          .animate-scroll-left {
            animation: scroll-left 40s linear infinite;
          }

          .animate-scroll-right {
            animation: scroll-right 45s linear infinite;
          }

          .paused {
            animation-play-state: paused !important;
          }
        ` }), jsx("div", Object.assign({ style: { display: "flex", flexDirection: "column", gap: "12px" } }, { children: duplicatedRows.map((row, rowIndex) => (jsx("div", Object.assign({ className: `${rowIndex % 2 === 0
                        ? "animate-scroll-left"
                        : "animate-scroll-right"} ${isPaused ? "paused" : ""}`, style: {
                        display: "flex",
                        gap: "8px",
                        width: "max-content",
                    } }, { children: row.map((item, itemIndex) => (jsx(Card, { title: "Suggested search", description: item, onClick: () => onItemClick(item) }, `${rowIndex}-${itemIndex}`))) }), rowIndex))) }))] })));
};

export { AnimatedMasonryGrid, Card as default };
//# sourceMappingURL=AnimatedMasonryGrid.js.map
